const AllFilter = {
	ALL_FLAGS_READABLE: "All Flags",
	// ALL_SHIPS is used here instead of ALL_VESSELS as the backend uses ALL_SHIPS and the string is just a nice display for the dropdown.
	ALL_SHIPS_READABLE: "All Vessels",
	ALL_FLAGS: "ALL_FLAGS",
	ALL_SHIPS: "ALL_SHIPTYPES"
};
export default AllFilter;
